import { Component, OnInit } from '@angular/core';
import { GlobalServiceService } from '../global-service.service';

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.css']
})
export class QuotesComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.221;
  constructor(private service: GlobalServiceService) { }

  ngOnInit(){
    this.onResize();
  }

  onResize(){
    this.height = this.service.getHeight(this.proportion);
  }

  setFirstQuote(e){
    this.changeQuote(e);
   $('.quote:nth-child(2)').addClass('activeQuote');
  }

  setSecondQuote(e){
    this.changeQuote(e);
    $('.quote:nth-child(3)').addClass('activeQuote');
  }

  setThirdQuote(e){
    this.changeQuote(e);
    $('.quote:nth-child(4)').addClass('activeQuote');
  }



  changeQuote(event){
    this.clearAll();
   let target = event.target;
   $(target).addClass('activeSwitch');
  };

  clearAll(){
    $('.activeQuote').removeClass('activeQuote');
    $('.activeSwitch').removeClass('activeSwitch');
  };

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/about us/quotes.component.ts